import { useForm } from 'react-hook-form'
import { LoginFormInputs } from './types'
import { useNavigate, useOutletContext } from 'react-router'
import { AuthContextType } from 'pages/Auth/types.ts'
import { useStoreDispatch } from 'hooks/store.ts'
import { login } from 'store/auth/thunks'
import { Banner, Button, Form, Password, TextField } from '@boltenergy-be/design-system'
import { EmailRegex } from '@boltenergy-be/shared'

const Login = () => {
  // Redux state
  const dispatch = useStoreDispatch()

  // Routing
  const navigate = useNavigate()
  const { loading, error } = useOutletContext<AuthContextType>()

  // React hook form
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<LoginFormInputs>()

  /**
   * Handles the login after validation by React Hook Form
   * @param {LoginFormInputs} data
   */
  const onSubmit = (data: LoginFormInputs) => {
    const { email, password } = data
    dispatch(login({ email, password, navigate }))
  }

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <TextField
        {...register('email', {
          required: 'This field is required',
          pattern: { value: EmailRegex, message: 'Please fill in a valid email address' }
        })}
        type="email"
        label="Email"
        grid="full"
        error={errors?.email?.message}
      />

      <Password
        {...register('password', { required: 'This field is required' })}
        label="Password"
        grid="full"
        error={errors?.password?.message}
      />

      <Form.Footer className="grid-col-full">
        {!loading && error && <Banner type="blocking" title="Login failed" className="mb-400" />}

        <Button {...{ loading }} isFullwidth>
          Login
        </Button>
      </Form.Footer>
    </Form>
  )
}

export default Login
